import request from "@/axios/axios";
import urlF from "@/axios/url";

const url = urlF();
const local = window.location.origin;

export function getSectorList(data) {
  return request({
    url: `${url.baseUrl}index/sectorList`,
    method: "get",
    data,
  });
}
export function getSectorPlateForm(data) {
  return request({
    url: `${url.baseUrl}index/sectorPlateForm`,
    method: "post",
    data,
  });
}

export function getIndexBottomData(data) {
  return request({
    url: `${url.baseUrl}index/bottomData`,
    method: "get",
  });
}
export function getToken(data) {
  return request({
    url: `${url.serviceUrl}oauth2/token`,
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  });
}

export function indexTest(data) {
  return request({
    url: `${url.baseUrl}index/indexTest`,
    method: "get",
    // headers: {
    //   Authorization: `${data.token}`
    // },
    // data
  });
}
export function menuList(data) {
  return request({
    url: `${url.baseUrl}index/menuList`,
    method: "get",
    // headers: {
    //   Authorization: `${data.token}`
    // },
    // data
  });
}
export function signOut(data) {
  return request({
    url: `${url.baseUrl}index/signOut`,
    method: "get",
    // headers: {
    //   Authorization: `${data.token}`
    // },
    // data
  });
}
export function getUserInfo(data) {
  return request({
    url: `${url.baseUrl}index/userInfo?userId=${data}`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "get",
  });
}
// 历史记录
export function getHistoryList(data) {
  return request({
    url: `${url.baseUrl}index/getBaseUserPermApplyList?userId=${data}`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "get",
  });
}
// GET /index/roleResourceList /* 角色及角色下资源 */
export function getRoleResourceList(data) {
  return request({
    url: `${url.baseUrl}index/roleResourceList`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "post",
    data
  });
}
export function permApply(data) {
  return request({
    url: `${url.baseUrl}index/permApply`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "post",
    data
  });
}
export function getRoleList(data) {
  return request({
    url: `${url.baseUrl}index/roleList`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "post",
    data
  });
}
//密码修改
export function passwordVerification(data) {
  return request({
    url: `${url.baseUrl}index/passwordVerification`,
    method: "post",
    data
  });
}
//门户修改个人头像
export function editAvatar(data) {
  return request({
    url: `${url.baseUrl}index/editAvatar`,
    method: "post",
    data
  });
}
//门户修改个人信息
export function editMyData(data) {
  return request({
    url: `${url.baseUrl}index/editMyData`,
    method: "post",
    data
  });
}
//门户修改个人信息
export function deleteUserRole(data) {
  return request({
    url: `${url.baseUrl}index/deleteUserRole`,
    method: "post",
    data
  });
}
///index/getMessageByUserId  /* 根据用户id获取消息 */
export function getMessageByUserId(params) {
  return request({
    url: `${url.baseUrl}index/getMessageByUserId`,
    method: "get",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  });
}

// /index/editMessageStatus /* 更新消息状态为已读 */

export function editMessageStatus(params) {
  return request({
    url: `${url.baseUrl}index/editMessageStatus`,
    method: "get",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  });

}
export function getNotShowPlatformNameList() {
  return request({
    url: `${url.baseUrl}index/getNotShowPlatformNameList`,
    method: "get",
  });

}

//
export function captcha() {
  return request({
    url: `${url.baseUrl}index/captcha`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "get",
    responseType: 'arraybuffer'
  });
}
// 获取mqtt
export function getMqttUrl() {
  return request({
    url: `${url.platformsvc}expose/middleware/url`,
    // url: `https://auth-test.gczx.com:8443/user/editmy`,
    method: "get",
  });
}

export function saveLogBuriedPoint(data) {
  return request({
    url: `${url.baseUrl}buriedPoint/saveLogBuriedPoint`,
    method: "post",
    data
  });
}

export function saveUserFeedBack(data) {
  return request({
    url: `${url.platformsvc}trafficReport/saveUserFeedBack`,
    method: "post",
    data
  });
}
